import { render, staticRenderFns } from "./myMain.vue?vue&type=template&id=29cda5ec&scoped=true&"
import script from "./myMain.vue?vue&type=script&lang=js&"
export * from "./myMain.vue?vue&type=script&lang=js&"
import style0 from "./myMain.vue?vue&type=style&index=0&id=29cda5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cda5ec",
  null
  
)

export default component.exports